// Fixed Uber/Rasier SC/NC/GA "Annual Vehicle Inspection" points (19 total),
// read from the official SC/NC/GA form. Column split: 1-10 left, 11-19 right.

export const scNcGeInspectionPoints = [
  { number: 1, label: "Foot brakes" },
  { number: 2, label: "Emergency brake (parking brake)" },
  { number: 3, label: "Steering mechanism" },
  { number: 4, label: "Windshield" },
  { number: 5, label: "Rear window and other glass" },
  { number: 6, label: "Windshield wipers" },
  { number: 7, label: "Headlights" },
  { number: 8, label: "Tail lights" },
  { number: 9, label: "Turn indicator lights" },
  { number: 10, label: "Brake lights" },
  { number: 11, label: "Front seat adjustment mechanism" },
  { number: 12, label: "Doors (open, close, lock)" },
  { number: 13, label: "Horn" },
  { number: 14, label: "Speedometer" },
  { number: 15, label: "Bumpers" },
  { number: 16, label: "Muffler and exhaust system" },
  { number: 17, label: "Tire condition including tread depth" },
  { number: 18, label: "Interior and exterior rear view mirrors" },
  { number: 19, label: "Safety belts for driver and passenger(s)" },
];

export const scNcGeInspectionColumns = [
  scNcGeInspectionPoints.slice(0, 10),
  scNcGeInspectionPoints.slice(10),
];

// Resolves PASS/FAIL for a point from the inspection checks (mapped by index).
export const getScNcGePointStatus = (checksData, index) => {
  const status = checksData?.[index]?.status;
  return {
    pass: status === true || status === 1,
    fail: status === false || status === 0,
  };
};
